export const GLOBAL_STATUS_OK = 0;
export const GLOBAL_STATUS_WARN = 1;
export const GLOBAL_STATUS_ERROR = 2;
export const HOST_STATUSES_KEY = 'HOST_STATUSES';
export const API_OPTIONS = { key: HOST_STATUSES_KEY };
